import React from "react";
import {useSelector, useDispatch} from 'react-redux'
import { cloneDeep } from "lodash";
import Dropdown from "../../../../Global/Dropdown";
import SIS from "Services/StudentInformationService";
import { setTrackingReport } from "../../../state/tracking/actions";
import { useTranslation } from "react-i18next";

export default function LanguageSelect(props) {
  const { student, index } = props;

  const {t} = useTranslation("reports");

  const trackingReportData = useSelector(
    (state) => state.reports.tracking.report.data
  );

  const dispatch = useDispatch();
  const setReport = (data) => dispatch(setTrackingReport(data));

  let language = "english";
  if (student.metadata.esl) language = "bilingual";

  return (
    <Dropdown
      value={{label: t(language)}}
      onChange={onChange}
      options={[
        { value: "english", label: t("english") },
        { value: "bilingual", label: t("bilingual") },
      ]}
    />
  );

  function onChange(option) {
    const metadata = cloneDeep(student.metadata)
    metadata.esl = option.value === "bilingual";
    SIS.updateStudentMetadata(student.studentId, metadata);

    // update metadata in the local state
    const trackingUpdate = cloneDeep(trackingReportData)
    trackingUpdate[index].metadata = metadata
    setReport(trackingUpdate)
  }
}